import { render, staticRenderFns } from "./BoContact.vue?vue&type=template&id=64442794&"
import script from "./BoContact.vue?vue&type=script&lang=js&"
export * from "./BoContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports